import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculationResource } from '../model/calculationResource';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThirdStepService } from './third-step.service';
import { CreateCustomerRequest } from '../model/createCustomerRequest';

@Component({
  selector: 'app-third-step',
  templateUrl: './third-step.component.html',
  styleUrls: ['./third-step.component.scss']
})
export class ThirdStepComponent implements OnInit {

  @Input() calculation: CalculationResource | undefined;
  @Output() finish = new EventEmitter<Boolean>();

  customerForm: FormGroup;
  wrongData = false;

  constructor(
    public _service: ThirdStepService,
    private _formBuilder: FormBuilder,
  ) {

    this.customerForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{9,15}$/)]],
    });

  }

  ngOnInit(): void {

    const savedFormData = localStorage.getItem('customerForm');

    if (savedFormData) {
      const parsedData = JSON.parse(savedFormData);
      this.customerForm.patchValue(parsedData);
    }

    this.customerForm.valueChanges.subscribe((formData) => {
      this.saveToLocalStorage();
    });

  }

  onSubmit(): void{
    if (this.customerForm.valid) {
      const formValues = this.customerForm.getRawValue();
      let output: CreateCustomerRequest = {
        name: formValues.name,
        email: formValues.email,
        phone: formValues.phone,
      };

      if(this.calculation){
        this._service.assignCustomer(String(this.calculation?.id) ,output).subscribe( () => {
          this.finish.emit(true);
        }, error => {
          this.wrongData = true;
        });
      }
    }
  }

  saveToLocalStorage(): void {
    const formData = this.customerForm.value;
    localStorage.setItem('customerForm', JSON.stringify(formData));
  }

  get formControls() {
    return this.customerForm.controls;
  }

}
